module.exports = __webpack_public_path__ + "static/media/collection-bird-05-effect.2ef59f85.png";